import { defineComponent, ref, computed, openBlock, createElementBlock, normalizeClass, createBlock, unref, withCtx, createVNode, createCommentVNode, createElementVNode, createStaticVNode, mergeProps, toDisplayString } from "vue";
import { CdrButton, IconPlayStroke } from "@rei/cedar";
import GenericLazyImageLoader from "../GenericLazyImageLoader/GenericLazyImageLoader.mjs";
const _hoisted_1 = ["data-ui"];
const _hoisted_2 = ["tabindex"];
const _hoisted_3 = ["data-ui"];
const _hoisted_4 = {
  key: 0,
  title: "YouTubeLogo",
  class: "generic-media__youtube-logo",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 443.06 148.61"
};
const _hoisted_5 = {
  key: 1,
  class: "generic-media__overlay"
};
const _hoisted_6 = {
  key: 2,
  class: "generic-media__caption-wrapper"
};
const _hoisted_7 = {
  class: "generic-media__caption-text"
};
const _hoisted_8 = {
  key: 1,
  "data-ui": "video-player",
  class: "generic-media__video-wrapper"
};
const _hoisted_9 = ["title", "src"];
const _hoisted_10 = {
  key: 2,
  id: "video-description",
  class: "pdp-sr-only"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "GenericMedia",
  props: {
    className: {
      default: ""
    },
    dataColor: {
      default: ""
    },
    description: {
      default: ""
    },
    id: {
      default: ""
    },
    imageCaption: {
      default: ""
    },
    imageSrc: {
      default: ""
    },
    xlImageSrc: {
      default: ""
    },
    isFocusable: {
      type: Boolean,
      default: true
    },
    lazy: {
      type: Boolean,
      default: false
    },
    lazyOpts: {
      default: () => ({
        // IntersectionObserver options object
        observerOpts: {},
        // used in IntersectionObserver callback
        intersectionRatio: 0
      })
    },
    overrideImageStyle: {
      type: Boolean,
      default: false
    },
    resetVideoOverride: {
      type: Boolean,
      default: void 0
    },
    title: {
      default: ""
    },
    videoLinkName: {
      default: ""
    },
    videoSrc: {
      default: ""
    },
    role: {
      default: ""
    },
    tabIndex: {
      default: ""
    },
    showXlBreakpoint: {
      type: Boolean
    },
    isHero: {
      type: Boolean
    }
  },
  emits: ["metricsClick", "resetVideo"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const hotspotOverlayClass = ref("");
    const isVideoPlaying = ref(false);
    const computedClass = computed(() => props.overrideImageStyle ? "" : `generic-media__img ${props.className}`);
    const computedVideoPlaying = computed(() => {
      if (typeof props.resetVideoOverride === "boolean") return !props.resetVideoOverride;
      return isVideoPlaying.value;
    });
    const imageDataAttribute = computed(() => !props.videoSrc ? "data-color" : null);
    const videoDataAttribute = computed(() => props.videoSrc ? "data-ui" : null);
    const computedDataAttributes = computed(() => {
      const dataAttributes = {};
      if (imageDataAttribute.value) dataAttributes[imageDataAttribute.value] = props.dataColor;
      if (videoDataAttribute.value) dataAttributes[videoDataAttribute.value] = "video-preview-image";
      return dataAttributes;
    });
    function addOverlay() {
      hotspotOverlayClass.value = "overlay";
    }
    function removeOverlay() {
      hotspotOverlayClass.value = "";
    }
    function showVideo() {
      if (props.videoSrc) {
        isVideoPlaying.value = true;
        if (props.resetVideoOverride === true) emit("resetVideo", false);
        emit("metricsClick", {
          linkName: `${props.videoLinkName}`
        });
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", {
        ref: "container",
        class: normalizeClass(["generic-media", {
          "generic-media--video": _ctx.videoSrc
        }]),
        "data-ui": _ctx.videoSrc ? "video-player-wrapper" : void 0
      }, [!computedVideoPlaying.value && _ctx.imageSrc ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "generic-media__image-wrapper",
        "data-ui": "primary-image-container",
        tabindex: _ctx.tabIndex
      }, [_ctx.videoSrc && _ctx.isFocusable ? (openBlock(), createBlock(unref(CdrButton), {
        key: 0,
        "icon-only": true,
        "aria-label": `Play ${_ctx.title}`,
        "aria-describedby": "video-description",
        class: "generic-media__play-button",
        "data-ui": "video-play-button",
        onFocusin: _cache[0] || (_cache[0] = ($event) => addOverlay()),
        onMouseover: _cache[1] || (_cache[1] = ($event) => addOverlay()),
        onFocusout: _cache[2] || (_cache[2] = ($event) => removeOverlay()),
        onMouseleave: _cache[3] || (_cache[3] = ($event) => removeOverlay()),
        onClick: _cache[4] || (_cache[4] = ($event) => showVideo())
      }, {
        default: withCtx(() => [createVNode(unref(IconPlayStroke), {
          class: "generic-media__play-icon"
        })]),
        _: 1
      }, 8, ["aria-label"])) : createCommentVNode("", true), createElementVNode("div", {
        class: normalizeClass([_ctx.videoSrc ? `generic-media__hotspot ${hotspotOverlayClass.value}` : "generic-media__no-hotspot"]),
        "aria-hidden": "true",
        tabindex: "-1",
        "data-ui": _ctx.videoSrc ? "video-play-hotspot" : "",
        onClick: showVideo
      }, [_ctx.videoSrc ? (openBlock(), createElementBlock("svg", _hoisted_4, _cache[5] || (_cache[5] = [createStaticVNode('<path d="M150.08,45.4a15.25,15.25,0,0,0-10.74-10.74c-9.48-2.53-47.47-2.53-47.47-2.53s-38,0-47.46,2.53A15.23,15.23,0,0,0,33.67,45.4c-2.54,9.48-2.54,29.24-2.54,29.24s0,19.77,2.54,29.25a15.23,15.23,0,0,0,10.74,10.74c9.47,2.53,47.46,2.53,47.46,2.53s38,0,47.47-2.53a15.25,15.25,0,0,0,10.74-10.74c2.54-9.48,2.54-29.25,2.54-29.25S152.62,54.88,150.08,45.4ZM79.72,92.87V56.42l31.57,18.23Z" style="fill:#fff;" data-v-85eb3015></path><path d="M207.47,109.49a13.19,13.19,0,0,1-5.13-7.56,49.63,49.63,0,0,1-1.52-13.64V80.56a44.75,44.75,0,0,1,1.74-13.81A13.9,13.9,0,0,1,208,59.14q3.69-2.39,9.68-2.38t9.47,2.43a13.89,13.89,0,0,1,5.22,7.6A46.66,46.66,0,0,1,234,80.56v7.73A47.38,47.38,0,0,1,232.4,102a13.42,13.42,0,0,1-5.21,7.56c-2.41,1.59-5.66,2.39-9.78,2.39S209.87,111.11,207.47,109.49Zm13.46-8.34q1-2.61,1-8.51V76q0-5.73-1-8.38A3.57,3.57,0,0,0,217.41,65,3.52,3.52,0,0,0,214,67.66,25.81,25.81,0,0,0,213,76v16.6q0,5.89,1,8.51a3.48,3.48,0,0,0,3.47,2.6A3.56,3.56,0,0,0,220.93,101.15Z" style="fill:#fff;" data-v-85eb3015></path><path d="M392,88.42v2.69a72.09,72.09,0,0,0,.3,7.69,7.3,7.3,0,0,0,1.26,3.74,3.59,3.59,0,0,0,2.95,1.17,3.73,3.73,0,0,0,3.7-2.09c.66-1.39,1-3.7,1.08-7l10.34.61a15.78,15.78,0,0,1,.09,1.91c0,4.93-1.35,8.6-4,11s-6.5,3.64-11.43,3.64c-5.9,0-10.05-1.85-12.42-5.56s-3.56-9.44-3.56-17.2V79.82q0-12,3.69-17.51t12.64-5.52c4.11,0,7.27.76,9.47,2.26a12.17,12.17,0,0,1,4.65,7,50.78,50.78,0,0,1,1.35,13.21v9.12ZM393.51,66a7.34,7.34,0,0,0-1.22,3.7,73,73,0,0,0-.3,7.77v3.82h8.77V77.47a64.62,64.62,0,0,0-.35-7.77A7.4,7.4,0,0,0,399.15,66a3.48,3.48,0,0,0-2.82-1.09A3.42,3.42,0,0,0,393.51,66Z" style="fill:#fff;" data-v-85eb3015></path><path d="M178.27,87.42,164.63,38.16h11.9l4.78,22.33q1.83,8.25,2.7,14.07h.34q.61-4.17,2.7-14L192,38.16h11.9L190.09,87.42v23.63H178.27Z" style="fill:#fff;" data-v-85eb3015></path><path d="M272.72,57.8v53.25h-9.39l-1-6.51H262q-3.82,7.38-11.47,7.38-5.3,0-7.82-3.47t-2.52-10.86V57.8h12V96.89A11.73,11.73,0,0,0,253,102a2.69,2.69,0,0,0,2.6,1.52,5.32,5.32,0,0,0,3-.95,6,6,0,0,0,2.13-2.43V57.8Z" style="fill:#fff;" data-v-85eb3015></path><path d="M334.21,57.8v53.25h-9.38l-1-6.51h-.26q-3.82,7.38-11.47,7.38-5.3,0-7.82-3.47t-2.52-10.86V57.8h12V96.89a11.92,11.92,0,0,0,.78,5.08,2.7,2.7,0,0,0,2.61,1.52,5.32,5.32,0,0,0,3-.95,6,6,0,0,0,2.12-2.43V57.8Z" style="fill:#fff;" data-v-85eb3015></path><path d="M305.3,47.81H293.39v63.24H281.66V47.81h-11.9V38.16H305.3Z" style="fill:#fff;" data-v-85eb3015></path><path d="M373.89,66.31c-.72-3.36-1.9-5.79-3.52-7.3a9.47,9.47,0,0,0-6.69-2.26,11.11,11.11,0,0,0-6.16,1.87,12.72,12.72,0,0,0-4.44,4.91H353V35.47H341.44v75.58h9.91l1.21-5h.26a10.18,10.18,0,0,0,4.17,4.26,12.41,12.41,0,0,0,6.17,1.56,9.43,9.43,0,0,0,8.95-5.6Q375,100.62,375,88.72V80.3A69.41,69.41,0,0,0,373.89,66.31ZM362.9,88a67,67,0,0,1-.48,9.12,9.82,9.82,0,0,1-1.6,4.7,3.75,3.75,0,0,1-3,1.39,5.5,5.5,0,0,1-2.74-.7,5.24,5.24,0,0,1-2-2.08V70.22a7.61,7.61,0,0,1,2.08-3.56,4.66,4.66,0,0,1,3.22-1.39,3.26,3.26,0,0,1,2.82,1.43,11,11,0,0,1,1.39,4.83,90,90,0,0,1,.39,9.64Z" style="fill:#fff;" data-v-85eb3015></path>', 8)]))) : createCommentVNode("", true), _ctx.videoSrc ? (openBlock(), createElementBlock("div", _hoisted_5)) : createCommentVNode("", true), createVNode(unref(GenericLazyImageLoader), mergeProps({
        id: _ctx.id,
        key: "image",
        title: _ctx.title,
        class: [_ctx.videoSrc ? "generic-media__video-thumbnail" : computedClass.value],
        "image-src": _ctx.imageSrc,
        "xl-image-src": _ctx.xlImageSrc,
        alt: _ctx.videoSrc ? `Preview of ${_ctx.title}` : _ctx.title,
        lazy: _ctx.lazy,
        "lazy-opts": _ctx.lazyOpts
      }, computedDataAttributes.value, {
        "show-xl-breakpoint": _ctx.showXlBreakpoint,
        "is-hero": _ctx.isHero
      }), null, 16, ["id", "title", "class", "image-src", "xl-image-src", "alt", "lazy", "lazy-opts", "show-xl-breakpoint", "is-hero"]), _ctx.imageCaption && !_ctx.videoSrc ? (openBlock(), createElementBlock("div", _hoisted_6, [createElementVNode("span", _hoisted_7, toDisplayString(_ctx.imageCaption), 1)])) : createCommentVNode("", true)], 10, _hoisted_3)], 8, _hoisted_2)) : _ctx.videoSrc && computedVideoPlaying.value ? (openBlock(), createElementBlock("div", _hoisted_8, [createElementVNode("iframe", {
        title: _ctx.title,
        src: `${_ctx.videoSrc}?autoplay=1&rel=0`,
        class: "generic-media__iframe",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: ""
      }, null, 8, _hoisted_9)])) : createCommentVNode("", true), _ctx.description ? (openBlock(), createElementBlock("span", _hoisted_10, toDisplayString(_ctx.description), 1)) : createCommentVNode("", true)], 10, _hoisted_1);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=GenericMedia2.mjs.map
